import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGithub, 
  faLinkedin, 
  faMedium 
} from '@fortawesome/free-brands-svg-icons';

const SocialIcons = () => {

  const redirectTo = (url) => {
        window.open(url, '_blank'); // abre em nova aba
        window.focus(); // foca na nova aba};
  }

  return (
    <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 mb-4">
        <Button style={{ backgroundColor: '#343a40', color: 'white', borderColor: 'transparent' }} 
                className="mx-2 button"
                onClick={() => redirectTo('https://evertonzauso.medium.com/')}>    
            <FontAwesomeIcon icon={faMedium} className="me-2" />Medium
        </Button>
        <Button style={{ backgroundColor: '#343a40', color: 'white', borderColor: 'transparent' }} 
            className="mx-2 button"
            onClick={() => redirectTo('https://www.linkedin.com/in/everton-souza-780b18137')}>    
            <FontAwesomeIcon icon={faLinkedin} className="me-2" />LinkedIn
        </Button>    
        <Button style={{ backgroundColor: '#343a40', color: 'white', borderColor: 'transparent' }} 
                className="mx-2 button"
                onClick={() => redirectTo('https://github.com/evertonzauso777')}>    
            <FontAwesomeIcon icon={faGithub} className="me-2" />GitHub
        </Button>
    </div>
  );
};

export default SocialIcons;
